import styled from 'styled-components';

type Props = {
  $isLoading: boolean;
};

const StyledAuthButton = styled.button<Props>`
  width: 100%;
  padding: 0.75rem 1rem;
  background: rgba(134, 92, 208, 0.3);
  border: none;
  border-radius: 10px;
  font-size: 1.15rem;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  height: 52px;
  color: rgb(134, 92, 208);
  cursor: ${({ $isLoading }) => ($isLoading ? `not-allowed` : `pointer`)};
`;

const StyledAuthButtonWrapper = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export { StyledAuthButtonWrapper, StyledAuthButton };
